import React from 'react';
import { BulkUploadDrawer } from '../../common/bulk-upload';
import type { BulkUploadDrawerProps } from '../../common/bulk-upload';
import type { BulkUploadUserRow } from '../../../types/admin-users';

export interface AdminUsersBulkUploadDrawerProps
  extends Pick<
    BulkUploadDrawerProps<BulkUploadUserRow, BulkUploadUserRow>,
    | 'isOpen'
    | 'onClose'
    | 'fileInput'
    | 'validateConfig'
    | 'isBusy'
    | 'errorSection'
    | 'successSection'
    | 'footerActions'
    | 'contentSlot'
  > {
  onDownloadSample: () => void;
}

/**
 * Admin Users specific wrapper around the generic BulkUploadDrawer.
 * Keeps the parent component lightweight by configuring copy and props.
 */
export const AdminUsersBulkUploadDrawer: React.FC<AdminUsersBulkUploadDrawerProps> = ({
  isOpen,
  onClose,
  onDownloadSample,
  ...drawerProps
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <BulkUploadDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Bulk Upload Users"
      description="Upload a CSV file to create multiple users in one go."
      sampleFile={{
        label: 'Sample',
        onDownload: onDownloadSample,
      }}
      fileInput={drawerProps.fileInput}
      validateConfig={drawerProps.validateConfig}
      isBusy={drawerProps.isBusy}
      errorSection={drawerProps.errorSection}
      successSection={drawerProps.successSection}
      footerActions={drawerProps.footerActions}
      contentSlot={drawerProps.contentSlot}
    />
  );
};
